var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShow)?_c('div',{staticClass:"banner"},[_c(_vm.type,_vm._b({tag:"Component",attrs:{"bannerListData":_vm.bannerListData,"isMultBrow":_vm.isMultBrow},on:{"click":_vm.eEmitClick}},'Component',_vm.$props,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }